export const FORGOT_PASSWORD_CHANGE_REQUEST = 'FORGOT_PASSWORD_CHANGE_REQUEST';
export const FORGOT_PASSWORD_CHANGE_SUCCESS = 'FORGOT_PASSWORD_CHANGE_SUCCESS';
export const FORGOT_PASSWORD_CHANGE_FAILURE = 'FORGOT_PASSWORD_CHANGE_FAILURE';
